import {
    ReactElement,
} from 'react';

import {useNavigate} from 'react-router-dom';

import {
    Alert,
    SimpleGrid,
} from '@mantine/core';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';

import {useApplicationScreenshots} from '../hooks/useApplicationScreenshots.ts';
import {useApplicationScreenshotsFilter} from '../hooks/useApplicationScreenshotsFilter.ts';
import {useApplicationScreenshotsSelection} from '../hooks/useApplicationScreenshotsSelection.ts';
import {useApplicationScreenshotsSearch} from "../hooks/useApplicationScreenshotsSearch.ts";
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ApplicationScreenshot} from '../types';
import config from '../config';

export const RecordsTable = ({
                                 extraTools,
                             }: {
    extraTools?: ReactElement[],
}) => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const {filters} = useApplicationScreenshotsFilter();

    const {
        visibleItems,
        sortStatus,
        setSortStatus,
        loading,
        isError,
        columns,
    } = useApplicationScreenshots(filters);

    const {
        handleFilterByKeyword,
    } = useApplicationScreenshotsSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection,
    } = useApplicationScreenshotsSelection();

    const canDelete = allowedActions.includes(rbacActions.DeleteApplicationScreenshot);

    const selectedRecords = canDelete
        ? visibleItems.filter(record => selection[record.id] === true)
        : undefined;

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            {extraTools}

            {isError && (
                <Alert color='red' title='Could not load screenshots'>
                    The screenshots API did not return the list. Try Reload; if it persists
                    the API may be unavailable in this environment.
                </Alert>
            )}

            <MantineDataTable<ApplicationScreenshot>
                columns={columns}
                records={visibleItems}
                // Sorting is client-side over the records loaded so far — the same
                // scope the keyword filter works on.
                sortStatus={sortStatus}
                onSortStatusChange={setSortStatus}
                fetching={loading}
                noRecordsText='No screenshots yet'
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={canDelete ? (items) => {
                    handleClearSelection();
                    (items as ApplicationScreenshot[]).forEach(item => {
                        handleRowSelection(item.id, true);
                    });
                } : undefined}
                withTableBorder={true}
                onRowClick={({record}) =>
                    navigate(`${config.basePath}/${encodeURIComponent(record.id)}`)}
            />
        </SimpleGrid>
    );
};
